import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import Company from "@/interfaces/Company";
import { IFilters } from "@/interfaces/Fetch";
import {
  useDeleteCompanyCourseMutation,
  useGetCompanyCoursesQuery,
} from "@/services/companies/courses";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { FC, useEffect, useState } from "react";
import { ToastContentProps, toast } from "react-toastify";
import CoursesCard from "../courses/CoursesCard";

const CompanyCoursesCard: FC<
  PaginateCardProps & IFilters & { id: string; company?: Company }
> = ({ onGetTotal, id, company, ...props }) => {
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 10,
    ...props,
  });
  const [deleteCompanyCourseAsync] = useDeleteCompanyCourseMutation();

  const { data, isLoading, isError, error } = useGetCompanyCoursesQuery([
    id,
    filters,
  ]);

  const onDelete = async (courseId: string) => {
    toast.promise(deleteCompanyCourseAsync([id, courseId]).unwrap(), {
      pending: "Suppression de la formation en cours...",
      success: {
        render() {
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              La formation à bien été supprimée 🤩
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "Les champs que vous avez remplis semblent être incorrects.";
          }

          return "Une erreur est survenue";
        },
      },
    });
  };

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader />;
  } else if (isError) {
    return <ErrorComponent error={error} />;
  }

  return (
    <CoursesCard
      data={data?.data}
      company={company}
      meta={data?.meta}
      onDelete={onDelete}
      filters={filters}
      setFilters={setFilters}
    />
  );
};

export default CompanyCoursesCard;
